import { observable, action, computed } from 'mobx'
import moment from 'moment'
import Parse from 'parse'

class ConfigStore {

    @observable noRestrictionTime

    constructor() {
        this.noRestrictionTime = null
        this.whatsappGroupLink = null
    }

    @computed get isConfig() {
        return this.noRestrictionTime ? true : false
    }

    @action setParseConfig = (
        noRestrictionTime,
        whatsappGroupLink
    ) => {

        // Server time is -2, so we have to set "15:00:00" to "17:00:00"
        let adjustedRestrictionTime = moment(noRestrictionTime, "HH:mm:ss").clone().add(2, "hours").format("HH:mm:ss")

        this.noRestrictionTime = adjustedRestrictionTime
        this.whatsappGroupLink = whatsappGroupLink
    }

    getParseConfig = () => {

        let noRestrictionTime = null
        let whatsappGroupLink = null

        Parse.Config.get().then(function(config) {
            noRestrictionTime = config.get("NO_RESTRICTION_TIME");
            whatsappGroupLink = config.get("WHATSAPP_GROUP_LINK")
        }, (error) => {
            console.error("Could not get Parse Config", error)
        }).then(() => {
            this.setParseConfig(
                noRestrictionTime,
                whatsappGroupLink
            )
        })
    }
}

const store = new ConfigStore()
export default store



// WEBPACK FOOTER //
// /src/stores/ConfigStore.js